var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar",class:_vm.size,style:(_vm.getBgImage)})
}
var staticRenderFns = []

export { render, staticRenderFns }